<template>
  <div class="networkSettings">

  </div>
</template>

<script>
export default {
    name: 'NetworkSettings',
}
</script>

<style scoped>
.networkSettings {
  position: absolute;
  bottom: 51px;
  right: 5px;
  
  width: 350px;
  height: 250px;
  padding: 3px;
  border-radius: 8px;

  background-color: var(--main-bg);
  border: var(--border);

  display: flex;
}
</style>